import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'connected-react-router';
import { startViewAs } from '../../modules/auth';
import { showErrors } from '../../modules/general';

const mapStateToProps = (state) => {
	return {
		authUser: state.auth.authUser,
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			startViewAs,
			showErrors,
			push,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
